<template>
  <div class="el-list">
    <ul>
      <li class="base-border">
        <p
          v-for="(item, index) in list.Data"
          :key="index"
          class="list-item"
        >
          <span @click="viewArticle(item)">{{ item.Title }}</span>
          <img
            v-if="item.Locked && !isLogin"
            class="name-lock"
            src="../../assets/img/lock.png"
          >
          <span class="date float-right">{{ showTime(item) }}</span>
        </p>
      </li>
    </ul>
    <div class="pagination">
      <el-pagination
        :page-size="20"
        :total="list.Total"
        class="float-right"
        layout="total, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'ListMore',
  props: ['list'],
  computed: {
    ...mapState({
      isLogin: 'isLogin'
    })
  },
  methods: {
    ...mapMutations({
      loginShow: 'LOGIN_SHOW'
    }),
    handleCurrentChange (currentPage) {
      this.$emit('pageChange', currentPage)
    },
    viewArticle (item) {
      if (item.Locked && !this.isLogin) {
        this.loginShow()
      } else {
        this.$emit('showArticle', item.Id)
      }
    },
    showTime (item) {
      return window.moment(item.PublishTime).format('YYYY-MM-DD')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/history/document-list.vue